import { render, staticRenderFns } from "./SendToVacation.vue?vue&type=template&id=2d233ea9"
import script from "./SendToVacation.vue?vue&type=script&lang=js"
export * from "./SendToVacation.vue?vue&type=script&lang=js"
import style0 from "./SendToVacation.vue?vue&type=style&index=0&id=2d233ea9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports